var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "stepsBox" },
    [
      _c("div", { staticClass: "acea-row mb25" }, [
        _c("div", { staticClass: "shu mr10" }),
        _vm._v(" "),
        _c("span", { staticClass: "title" }, [
          _vm._v("\n      审批流程\n      "),
          _vm.approverDelete || _vm.copyerDelete
            ? _c("i", { staticClass: "tit1" }, [
                _vm._v(
                  "（已由管理员预设不可" +
                    _vm._s(_vm.title01.substring(1)) +
                    "）"
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "el-steps",
        { attrs: { direction: "vertical" } },
        _vm._l(_vm.examineList, function (item, index) {
          return _c("el-step", { key: index }, [
            _c(
              "div",
              {
                staticClass: "caption",
                attrs: { slot: "title" },
                slot: "title",
              },
              [
                _vm._v("\n        " + _vm._s(item.title) + "\n        "),
                item.types == 1 &&
                item.settype != 5 &&
                item.examine_mode > 0 &&
                item.users.length > 1
                  ? _c("el-tag", { attrs: { effect: "plain", size: "mini" } }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.getExamineText(item.examine_mode)) +
                          "\n        "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                item.types == 1 && item.settype === 4
                  ? _c("span", { staticClass: "color-tab tab-icon" }, [
                      _vm._v("*"),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.judgeNodeText(item)
                  ? _c("span", { staticClass: "tip-title color-tab" }, [
                      _vm._v(_vm._s(_vm.judgeNodeText(item))),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "liuchen", attrs: { slot: "icon" }, slot: "icon" },
              [
                _c("i", {
                  class:
                    item.types == 1 ? "el-icon-s-check" : "el-icon-s-promotion",
                }),
              ]
            ),
            _vm._v(" "),
            _c("div", { attrs: { slot: "description" }, slot: "description" }, [
              _c(
                "div",
                { staticClass: "acea-row" },
                [
                  _vm._l(item.users, function (items, indexs) {
                    return _c(
                      "div",
                      {
                        key: indexs,
                        staticClass: "manList acea-row row-between-wrapper",
                      },
                      [
                        items.card || items.avatar
                          ? _c("img", {
                              staticClass: "mb10",
                              attrs: {
                                src: items.card
                                  ? items.card.avatar
                                  : items.avatar,
                              },
                            })
                          : _c("img", {
                              staticClass: "mb10",
                              attrs: {
                                src: require("../../../../assets/images/portrait.png"),
                              },
                            }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(items.card ? items.card.name : items.name)
                          ),
                        ]),
                        _vm._v(" "),
                        !items.isDelete
                          ? _c(
                              "span",
                              {
                                staticClass: "acea-icon",
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteUsersItem(
                                      item.users,
                                      indexs
                                    )
                                  },
                                },
                              },
                              [_c("i", { staticClass: "el-icon-close" })]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.types == 1 &&
                        item.examine_mode == 3 &&
                        indexs !== item.users.length - 1
                          ? _c("div", { staticClass: "acea-arrow-right" }, [
                              _c("i", { staticClass: "el-icon-arrow-right" }),
                            ])
                          : _vm._e(),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c("select-member", {
                    ref: "selectMember",
                    refInFor: true,
                    attrs: {
                      "only-one": item.select_mode == 1 ? true : false,
                      value: item.users || [],
                    },
                    on: {
                      getSelectList: function ($event) {
                        return _vm.getSelectList($event, item)
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "custom",
                          fn: function () {
                            return [
                              item.types == 1 && (item.options || _vm.editUser)
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "upload",
                                      on: {
                                        click: function ($event) {
                                          return _vm.openDepartment(item, index)
                                        },
                                      },
                                    },
                                    [_c("i", { staticClass: "el-icon-plus" })]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.types == 2 && item.self_select == 1
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "upload",
                                      on: {
                                        click: function ($event) {
                                          return _vm.openDepartment(item, index)
                                        },
                                      },
                                    },
                                    [_c("i", { staticClass: "el-icon-plus" })]
                                  )
                                : _vm._e(),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                2
              ),
            ]),
          ])
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }